/**
 * Outlet guard for the admin route branch. Wraps every ``/admin/*``
 * route after the existing ``RequireAuth`` gate has confirmed there
 * is a session: refuses entry to plain users and redirects them to
 * ``/today``. ``admin`` and ``superadmin`` both pass; the role-change
 * dialog is itself superadmin-gated server-side, so the SPA only
 * needs the coarse check here.
 */

import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../auth/AuthProvider";

export function RequireAdmin(): JSX.Element {
  const { user } = useAuth();
  const role = user?.role ?? "user";
  if (role !== "admin" && role !== "superadmin") {
    return <Navigate to="/today" replace />;
  }
  return <Outlet />;
}
